import { render, staticRenderFns } from "./anquanmao.vue?vue&type=template&id=bd45630c&scoped=true"
var script = {}
import style0 from "./anquanmao.vue?vue&type=style&index=0&id=bd45630c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd45630c",
  null
  
)

export default component.exports